<script>
import Swal from 'sweetalert2'

import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Helper from '@/helpers/helper';

import { ref } from "vue";


/**
 * Dashboard Component
 */
export default {
    setup() {
        const doesAddOpen = ref(false);
        const doesEditOpen = ref(false);
        const doesDeleteOpen = ref(false);
        const doesLoadingOpen = ref(false);
        const doesReceiptOpen = ref(false);

        return {
          doesAddOpen,
          doesEditOpen,
          doesDeleteOpen,
          doesLoadingOpen,
          doesReceiptOpen,
        };
    },
    page: {
    title: "aggregator transaction",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "aggregators transactions",
      items: [
        {
          text: "Menu",
        },
        {
          text: "aggregators transactions",
          active: true,
        },
      ],
      errors: [],
      aggregator_transaction: {},
      aggregator_transactions: [],  
      methods: [],
      aggregators: [],
      
      amount: 0,
      type: "deposit",
      rateType: "percent",
      balance: 0,
      available: 0,
      aggregator_id: "",
      method_id: "",
      
      loading: false,
      
      status: 201,
    };
  },
  methods: {
    toDate(date) {
      return Helper.toDate(date) 
    },
    loadList() {
      fetch(Helper.route('aggregators-transactions'), Helper.requestOptionsJSON())
      .then(response => {
          Helper.tokenChecker(response.status)
          return response.json()
      })
      .then(data => {
        this.aggregator_transactions = data        
        this.doesLoadingOpen = false

        console.log(data);
        
      })
    },
    loadMethods() {
      fetch(Helper.route('methods'), Helper.requestOptionsJSON())
      .then(response => {
          Helper.tokenChecker(response.status)
          return response.json()
      })
      .then(data => {
        this.methods = data
      })
    },
    loadAggregators() {
      fetch(Helper.route('aggregators'), Helper.requestOptionsJSON())
      .then(response => {
          Helper.tokenChecker(response.status)
          return response.json()
      })
      .then(data => {
        this.aggregators = data
        this.doesLoadingOpen = false
      })
    },
    addItem() {
      this.loading = true
      this.errors = []
      let body = {
        "amount": parseFloat(this.amount),
        "type": this.type,
        "aggregator": {
          "id": this.aggregator_id
        }
      }
      
      fetch(Helper.route('aggregators-transactions'), Helper.requestOptionsJSON("POST", body))
      .then(response => {
          //Helper.tokenChecker(response.status)
          this.status = response.status
          return response.json()
      })
      .then(data => {
        console.log(data);
        
        this.loading = false
        if (this.status == 201) {
          this.doesAddOpen = false
          this.aggregator_transactions.push(data) 
          Swal.fire("Aggregator Transactions ajouter !", "Aggregator Transactions a été enregistré avec succès.", "success");
        } else {
            this.errors.name = Helper.getError(data, "aggregator_transaction_name")
        }
      })
      .catch(error => {
        console.log(error);
        this.loading = false
      })
    },
    addReceipt() {
      this.loading = true
      this.errors = []
      let data = new FormData();

      const receiptFile = document.getElementById('receipt').files[0];
      if (receiptFile) {
          data.append('doc', receiptFile);
      } else {
        Swal.fire("Erreur !", "Facture requis", "error");
      }
      
      
      fetch(Helper.route('aggregators-transactions/'+this.aggregator_transaction.id+'/receipt'), Helper.requestOptions("POST", data))
      .then(response => {
          console.log(response.status);
          this.status = response.status
          return response.json()
      })
      .then(data => {
        console.log(data);
        
        this.loading = false
        
        if (this.status == 201) {
          this.doesReceiptOpen = false
          this.aggregator_transactions = this.aggregator_transactions.map(i => i.id !== this.aggregator_transaction.id ? i : data)
          Swal.fire("Facture envoyé !", "Facture envoyé avec succès.", "success");
        } else {
            this.errors.name = Helper.getError(data, "aggregator_transaction_name")
        }
      })
      .catch(error => {
        console.log(error);
        this.loading = false
      })
    },
    editItem() {
      this.loading = true
      this.errors = []
      let body = {
        "amount": parseFloat(this.amount),
        "type": this.type,
        "aggregator": {
          "id": this.aggregator_id
        }
      }

      fetch(Helper.route('aggregators-transactions/'+this.aggregator_transaction.id), Helper.requestOptionsJSON("PUT", body))
      .then(response => {
          Helper.tokenChecker(response.status)
          this.status = response.status
          return response.json()
      })
      .then(data => {
        console.log(this.status);
        this.loading = false
        if (this.status == 200) {
          this.doesEditOpen = false
          this.aggregator_transactions = this.aggregator_transactions.map(i => i.id !== this.aggregator_transaction.id ? i : data)
          Swal.fire("Aggregator Transactions modifier !", "Aggregator Transactions a été modifié avec succès.", "success");
        } else {
            this.errors.name = Helper.getError(data, "aggregator_transaction_name")
        }
      })
      .catch(error => {
        console.log(error);
        this.loading = false
      })
    },
    deleteIt() {
      this.loading = true
      fetch(Helper.route('aggregators-transactions/'+this.aggregator_transaction.id), Helper.requestOptions("DELETE"))
      .then(response => {
          Helper.tokenChecker(response.status)
          this.status = response.status
          return response.text()
      })
      .then(data => {
        console.log(this.status);
        console.log(data);
        if (this.status == 200) {
          this.aggregator_transactions = this.aggregator_transactions.filter(i => i.id !== this.aggregator_transaction.id)
          this.loading = false
          this.aggregator_transaction = null
          this.doesDeleteOpen = false
          Swal.fire("Aggregator Transactions supprimer !", "Aggregator Transactions a été supprimé avec succès.", "success");
        } else {
          Swal.fire("Aggregator Transactions non supprimer ?", "La suppression n'a pas marché, veuillez réessayez plus tard.", "error");
        }
      })
    },
    initItem(aggregator_transaction, action="edit") {
      this.aggregator_transaction = aggregator_transaction
      this.initData(aggregator_transaction)
      if (action == "delete") {
        this.doesDeleteOpen = true
      } else if (action == "receipt") {
        this.doesReceiptOpen = true
      } else {
        this.doesEditOpen = true
      }
    },
    initData(item = null) {
      this.amount = item != null ? item.amount : ""
      this.type = item != null ? item.type : ""
      this.aggregator_id = item != null ? item?.aggregator?.id : ""
    }
  },
  mounted() {
    this.loadList()
    this.loadMethods()
    this.loadAggregators()
    this.doesLoadingOpen = false
  },
  watch: {
    doesAddOpen: function() {
      this.errors = []
      if (!this.doesAddOpen) {
        this.initData(null)
      }
    },
    doesEditOpen: function() {
      this.errors = []
      if (!this.doesEditOpen) {
        this.initData(null)
        this.aggregator_transaction = null
      }
    },
    doesDeleteOpen: function() {
      if (!this.doesDeleteOpen) {
        this.initData(null)
        this.aggregator_transaction = null
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="hstack mb-3" v-show="status != 403">
        <b-button variant="primary" @click="doesAddOpen = true" class="ms-auto">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Ajouter un nouveau
        </b-button>
    </div>
    
    <div class="row" v-show="status != 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des aggregateurs transactions</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>aggregateurs transactions</code>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Aggreagateur</th>
                    <th>Type</th>
                    <th>Montant</th>
                    <th>Disponible</th>
                    <th>Balance</th>
                    <th>Reçu</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(aggregator_transaction, i) in aggregator_transactions" :key="aggregator_transaction.id">
                    <th scope="row">{{ i + 1 }}</th>
                    <td>
                      {{ aggregator_transaction?.aggregator?.name }}
                    </td>
                    <td>
                      {{ aggregator_transaction?.type }}
                    </td>
                    <td>
                      {{ Number(aggregator_transaction?.amount) }}
                    </td>
                    <td>
                      {{ Number(aggregator_transaction?.available) }}
                    </td>
                    <td>
                      {{ Number(aggregator_transaction?.balance )}}
                    </td>
                    <td>
                      <template v-if="aggregator_transaction.receipt">
                          <a :href="aggregator_transaction.receipt" target="_blank" class="btn btn-primary">Voir le reçu</a>
                      </template>
                      <template v-else>
                          <button class="btn btn-warning" @click="initItem(aggregator_transaction, 'receipt')">Envoyer le reçu</button>
                      </template>
                    </td>
                    <td>
                      {{ toDate(aggregator_transaction?.createdAt) }}
                    </td>
                    <!-- <td class="hstack">
                        <b-button class="btn-sm ms-2" @click="initItem(aggregator_transaction, 'edit')" variant="success">
                            <i class="bx bx-edit font-size-16 align-middle mx-1"></i>
                        </b-button>
                        <b-button variant="danger" @click="initItem(aggregator_transaction, 'delete')" class="ms-2 btn-sm">
                          <i class="bx bx-trash font-size-16 align-middle mx-1"></i>
                        </b-button>
                    </td> -->
                  </tr>
                </tbody>
              </table>
            </div>

            
          </div>
        </div>
      </div>
    </div>

    
    

    <div v-show="status === 403">
      <h3 class="text-danger text-center my-5">Réserver à l'administrateur principal</h3>
    </div>

    <!-- LOADING MODAL -->
    <b-modal v-model="doesLoadingOpen" id="modal-center" centered size="md" title="Chargement..."
      title-class="font-18" hide-footer>
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>

    <!-- ADD MODAL -->
    <b-modal
        v-model="doesAddOpen"
        id="modal-center"
        centered
        size="lg"
        title="Ajouter un aggregateur Transaction"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="addItem()">
          <div class="row">
            
            <div class="col-md-6 mb-3">
              <label for="">Montant</label>
              <input type="text" required v-model="amount" class="form-control">
              <span class="text-danger mt-2" v-if="errors.amount">{{ errors.amount }}</span>
            </div>

            <div class="col-md-6 mb-3">
              <label for="">Type</label>
              <select required v-model="type" class="form-control">
                <option value="deposit">Dépôt</option>
                <option value="withdraw">Retrait</option>
              </select>
              <span class="text-danger mt-2" v-if="errors.type">{{ errors.type }}</span>
            </div>
              
            <div class="col-md-12 mb-3">
              <label for="">Aggregator</label>
              <select required v-model="aggregator_id" class="form-control">
                <option value=""></option>
                <template v-for="aggregator in aggregators" :key="aggregator.id">
                  <option :value="aggregator.id">{{ aggregator.name }}</option>
                </template>
              </select>
            </div>
<!--            
            <div class="col-md-12 mb-3">
                <label for="receipt">Reçu (Facultatif)</label>
                <input type="file" id="receipt" class="form-control">
            </div> -->

          </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>


    <!-- RECEIP MODAL -->
    <b-modal
        v-model="doesReceiptOpen"
        id="modal-center"
        centered
        size="md"
        title="Ajouter le reçu"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="addReceipt()">
          <div class="row">
            
            <div class="col-md-12 mb-3">
              <label for="">Reçu</label>
              <input type="file" required id="receipt" class="form-control">
            </div>
            
          </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>



    <!-- EDIT MODAL -->
    <b-modal
        v-model="doesEditOpen"
        id="modal-center"
        centered
        size="lg"
        title="Modifier un aggregateur méthode"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="editItem()">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="">Montant</label>
              <input type="text" required v-model="amount" class="form-control">
              <span class="text-danger mt-2" v-if="errors.amount">{{ errors.amount }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Type</label>
              <select required v-model="type" class="form-control">
                <option value="deposit">Dépôt</option>
                <option value="withdraw">Retrait</option>
              </select>
              <span class="text-danger mt-2" v-if="errors.type">{{ errors.type }}</span>
            </div>
              
            <div class="col-md-6 mb-3">
              <label for="">Aggregator</label>
              <select required v-model="aggregator_id" class="form-control">
                <option value=""></option>
                <template v-for="aggregator in aggregators" :key="aggregator.id">
                  <option :value="aggregator.id">{{ aggregator.name }}</option>
                </template>
              </select>
            </div>


             <!-- <div class="col-md-12 mb-3">
                <label for="receipt">Reçu (Facultatif)</label>
                <input type="file" id="receipt" class="form-control">
            </div> -->
            
          </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>


    <!-- DELETE MODAL -->
    <b-modal
        v-model="doesDeleteOpen"
        id="modal-center"
        title="Supprimer un échange"
        title-class="font-18"
        hide-footer
        >
        <p class="mb-2">
            Voulez-vous vraiment supprimer l'échange <b>{{ aggregator_transaction?.from?.name }} - {{ aggregator_transaction?.to?.name }}</b> ?
        </p>
        <div class="hstack mt-2" v-if="!loading">
          <button class="btn btn-dark ms-auto" @click="doesDeleteOpen = false">Annuler</button>
          <button class="ms-3 btn btn-danger" @click="deleteIt()">Supprimer</button>
        </div>
        <div class="text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
    </b-modal>


  </Layout>
</template>
